import Prism from "prismjs";
import PropTypes from "prop-types";
import React from "react";
import reactElementToJSXString from "react-element-to-jsx-string";

import "prismjs/components/prism-jsx";

var Preview = function Preview(_ref) {
  var _displayName = _ref.displayName,
      hiddenProps = _ref.hiddenProps,
      enhancedComponent = _ref.enhancedComponent;

  var code = reactElementToJSXString(enhancedComponent, {
    displayName: function displayName() {
      return _displayName ? _displayName : enhancedComponent.type.name;
    },
    filterProps: hiddenProps,
    sortProps: true,
    useBooleanShorthandSyntax: false,
    showDefaultProps: true
  });
  var htmlCode = Prism.highlight(code, Prism.languages.jsx);
  return React.createElement("pre", {
    className: "language-jsx",
    dangerouslySetInnerHTML: { __html: htmlCode }
  });
};

Preview.propTypes = process.env.NODE_ENV !== "production" ? {
  displayName: PropTypes.string,
  hiddenProps: PropTypes.arrayOf(PropTypes.string),
  enhancedComponent: PropTypes.element.isRequired
} : {};

Preview.defaultProps = {
  displayName: null,
  hiddenProps: []
};

export default Preview;